// extracted by mini-css-extract-plugin
export default {"Time":"Time_Time__WIhVN"};